/*
* Project: LegalPlace assistant
* File: src/redux/actions/views.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/
const PREVIEW_INDEX = 'PREVIEW_INDEX_';

function setPreviewIndex(val) {
  return {
    type: PREVIEW_INDEX,
    val,
  };
}

export {
  PREVIEW_INDEX,
  setPreviewIndex,
};



// WEBPACK FOOTER //
// ./src/redux/actions/views.js